// extracted by mini-css-extract-plugin
export default {"MainDiv":"CompletedOrder_MainDiv__FNr1s","TableDiv":"CompletedOrder_TableDiv__GR2Yf","TableButton":"CompletedOrder_TableButton__v3KCu"};